exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Home--MyProjects .box-panel--content {\n  padding: 0 15px; }\n\n.Home--MyProjects .table-head {\n  background-color: #ebf1f7;\n  padding: 15px; }\n\n.Home--MyProjects .table-row {\n  padding: 15px; }\n  .Home--MyProjects .table-row .progress {\n    height: 22px; }\n  .Home--MyProjects .table-row a {\n    font-size: 14px;\n    color: #5644e2; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/containers/Home.scss
// module id = 523
// module chunks = 0